import { Button, IconButton, TextField, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import { TextArea } from 'shared/components/Messaging/Messaging.styles';
import { ShareButtons, ShareCont } from './Share.styles';
import { IoIosLink } from 'react-icons/io';
import {
  EmailIcon,
  FacebookIcon,
  FacebookMessengerIcon,
  GabIcon,
  HatenaIcon,
  InstapaperIcon,
  LineIcon,
  LinkedinIcon,
  LivejournalIcon,
  MailruIcon,
  OKIcon,
  PinterestIcon,
  PocketIcon,
  RedditIcon,
  TelegramIcon,
  TumblrIcon,
  TwitterIcon,
  ViberIcon,
  VKIcon,
  WeiboIcon,
  WhatsappIcon,
  WorkplaceIcon,
  XIcon,
} from 'react-share';

import {
  EmailShareButton,
  FacebookShareButton,
  GabShareButton,
  HatenaShareButton,
  InstapaperShareButton,
  LineShareButton,
  LinkedinShareButton,
  LivejournalShareButton,
  MailruShareButton,
  OKShareButton,
  PinterestShareButton,
  PocketShareButton,
  RedditShareButton,
  TelegramShareButton,
  TumblrShareButton,
  TwitterShareButton,
  ViberShareButton,
  VKShareButton,
  WhatsappShareButton,
  WorkplaceShareButton,
  FacebookMessengerShareButton,
} from 'react-share';
import { CustomTooltip } from 'pages/Opportunities/components/CustomTooltip/CustomTooltip';

import { CONFIG } from 'shared/config';
import { IoClose } from 'react-icons/io5';

interface Props {
  url: string;
  close: VoidFunction;
  projectName?: string;
  roleName?: string;
}

const Share: React.FC<Props> = ({ url, close, projectName, roleName }) => {
  const [copy, setCopy] = useState(false);

  //check if url is project or role by getting the string after the base url
  const isProject = url.split('/').length === 4;

  const subject = `There is a ${isProject ? 'Project' : 'Role'} you may be interested in for '${projectName}' project`;
  const body = isProject
    ? `I noticed this '${projectName}' project on the Casting.com site and thought you may be interested in applying for one of the roles.`
    : `I noticed this project on the Casting.com site and thought you may be interested in applying for the role of '${roleName}' in '${projectName}' project.`;
  const finalBody = `${body} \n\n Click here to view this ${isProject ? 'Project' : 'Role'}: \n ${url}`;

  const title = `${subject} \n \n ${body} \n\n Click here to view this ${isProject ? 'Project' : 'Role'}: `;

  const copyLink = () => {
    navigator.clipboard.writeText(url).then(() => {
      if (copy) return;
      setCopy(true);
      setTimeout(() => {
        setCopy(false);
      }, 1500);
    });
  };

  return (
    <ShareCont>
      <IconButton style={{ position: 'absolute', right: 5, top: 5 }} onClick={close}>
        <IoClose />
      </IconButton>
      <Typography variant="h6">{isProject ? 'Share this Project via:' : 'Share this Role via:'}</Typography>
      <ShareButtons>
        <CustomTooltip title="Share via Email">
          <EmailShareButton subject={subject} body={finalBody} url={''}>
            <EmailIcon size={32} round />
          </EmailShareButton>
        </CustomTooltip>
        <CustomTooltip title="Share via Facebook">
          <FacebookShareButton url={url} title={title}>
            <FacebookIcon size={32} round />
          </FacebookShareButton>
        </CustomTooltip>
        <CustomTooltip title="Share via Facebook Messenger">
          <FacebookMessengerShareButton url={url} appId={CONFIG.FACEBOOK_APP_ID} title={title}>
            <FacebookMessengerIcon size={32} round />
          </FacebookMessengerShareButton>
        </CustomTooltip>
        <CustomTooltip title="Share via Twitter">
          <TwitterShareButton url={url} title={body}>
            <XIcon size={32} round />
          </TwitterShareButton>
        </CustomTooltip>
        <CustomTooltip title="Share via LinkedIn">
          <LinkedinShareButton
            url={url}
            title={subject}
            summary={body}
            // source="Check out this project"
          >
            <LinkedinIcon size={32} round />
          </LinkedinShareButton>
        </CustomTooltip>
        <CustomTooltip title="Share via Telegram">
          <TelegramShareButton url={url} title={title}>
            <TelegramIcon size={32} round />
          </TelegramShareButton>
        </CustomTooltip>
        <CustomTooltip title="Share via Whatsapp">
          <WhatsappShareButton url={url} title={title}>
            <WhatsappIcon size={32} round />
          </WhatsappShareButton>
        </CustomTooltip>
        <CustomTooltip title="Share via Viber">
          <ViberShareButton
            url={url}
            title={`Hey! Check out this ${isProject ? 'Project' : 'Role'}: \n \n`}
            // separator=":"
          >
            <ViberIcon size={32} round />
          </ViberShareButton>
        </CustomTooltip>
        <CustomTooltip title="Share via Reddit">
          <RedditShareButton url={url} title={finalBody}>
            <RedditIcon size={32} round />
          </RedditShareButton>
        </CustomTooltip>
      </ShareButtons>
      <Typography variant="h6" style={{ marginTop: 20 }}>
        Or copy link:
      </Typography>
      <TextArea
        style={{ marginTop: 10 }}
        multiline
        value={url}
        InputProps={{
          style: {
            marginTop: '10px !important',
            padding: 10,
          },
          endAdornment: (
            <Button
              style={{
                marginLeft: 10,
                backgroundColor: 'transparent',
              }}
              onClick={copyLink}
            >
              {copy ? 'Copied!' : 'Copy'}
            </Button>
          ),
          startAdornment: (
            <IoIosLink
              size={25}
              style={{
                marginRight: 10,
              }}
            />
          ),
        }}
      />
    </ShareCont>
  );
};

export default Share;
